import React from "react"
import { useTranslation } from "react-i18next"
import { Container, Row, Card, CardHeader, Table, Badge } from "reactstrap"
import Header from "../../components/Headers/Header"
import { getCourierOrders } from "../../apollo/server"
import { useQuery, gql } from "@apollo/client"

interface CourierOrder {
  _id: string
  orderId: string
  orderStatus: string
  paymentStatus: string
  createdAt: string
  courierDescription: string
  courierBudget: number
  courierFee: number
  authorizedAmount: number
  capturedAmount: number
  courierPhoto: string
  user?: { _id: string; name: string; phone: string }
}

const yen = (n: number) => `¥${Math.round(n || 0).toLocaleString()}`

// 何でも配送(お使い便)の注文監視（読み取り専用）。
// 実費確定(capture)は「担当配達員アプリ」で行う方針のため、管理画面は監視のみ。
const Courier: React.FC = () => {
  const { t } = useTranslation()
  const { loading, error, data } = useQuery(gql`${getCourierOrders}`, { fetchPolicy: "cache-and-network" })

  const orders: CourierOrder[] = (data && data.courierOrders) || []

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row className="mt-3">
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">{t("CourierMonitorTitle")}</h3>
                <small className="text-muted">{t("CourierMonitorHint")}</small>
              </CardHeader>

              {error && <p className="px-4">{`${t("Error")}! ${error.message}`}</p>}
              {loading && !data && <p className="px-4">{t("Loading")}</p>}
              {!loading && orders.length === 0 && <p className="px-4 text-muted">{t("CourierNoOrders")}</p>}

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">{t("CourierOrderId")}</th>
                    <th scope="col">{t("CourierUser")}</th>
                    <th scope="col">{t("CourierDescription")}</th>
                    <th scope="col">{t("CourierBudget")}</th>
                    <th scope="col">{t("CourierFee")}</th>
                    <th scope="col">{t("CourierAuthorized")}</th>
                    <th scope="col">{t("CourierStatus")}</th>
                    <th scope="col">{t("CourierCaptured")}</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map(o => {
                    const settled = o.paymentStatus === "PAID" || (o.capturedAmount || 0) > 0
                    return (
                      <tr key={o._id}>
                        <td>{o.orderId}</td>
                        <td>{o.user ? o.user.name : "-"}</td>
                        <td style={{ maxWidth: 220, whiteSpace: "normal" }}>{o.courierDescription}</td>
                        <td>{yen(o.courierBudget)}</td>
                        <td>{yen(o.courierFee)}</td>
                        <td>{yen(o.authorizedAmount)}</td>
                        <td>{o.orderStatus}</td>
                        <td>
                          {settled ? (
                            <Badge color="success" pill>
                              {t("CourierSettled")} {yen(o.capturedAmount)}
                            </Badge>
                          ) : (
                            <Badge color="warning" pill>
                              {t("CourierPending")}
                            </Badge>
                          )}
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  )
}

export default Courier
